import ContentstackUIExtension from '@contentstack/ui-extensions-sdk';
import type { ExtensionSdk } from './types';

/** Adapter: legacy UI Extensions SDK -> our ExtensionSdk. The only file that knows about it. */
export async function connectLegacySdk(): Promise<ExtensionSdk> {
  const ext = await ContentstackUIExtension.init();
  const { field, entry } = ext;

  return {
    config: ext.config ?? {},
    stackApiKey: String(ext.stack.getData().api_key ?? ''),
    field: field && {
      get: () => field.getData(),
      set: (value) => field.setData(value),
      onChange: (cb) => field.onChange(cb),
    },
    entry: entry && {
      get: () => entry.getData(),
      getFieldValue: (uid) => {
        try { return entry.getField(uid)?.getData(); } catch { return undefined; }
      },
      onChange: (cb) => entry.onChange(cb),
    },
    autoResize: () => ext.window.enableAutoResizing(),
  };
}
